
<div class="bd-example">
  <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
    <div class="carousel-indicators">
      <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-label="Slide 1"></button>
      <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2" aria-current="true"></button>
      <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
    </div>
    <div class="carousel-inner">
      <div class="carousel-item active sliderItem" style="background-image:url('assets/front/images/bg-s1.jpg');" >
        <div class="container">
          <div class="row">
            <div class="col-sm-8 slideContent">
              <span class="surTitreSlider">C'EST UN MODE DE VIE</span>
              <h2 class="titreSlider">Rendez l'ordinaire extraordinaire avec nos équipements sanitaires</h2>
              <button class="btn voirPlusBtnRouge">ACHETER MAINTENANT <i class="fa fa-chevron-right" aria-hidden="true"></i></button>
            </div>
            <div class="col-sm-4">

            </div>
          </div>
        </div>
      </div>
      <div class="carousel-item sliderItem" style="background-image:url('assets/front/images/bg-s2.jpg');" >
        <div class="container">
          <div class="row">
            <div class="col-sm-8 slideContent">
              <span class="surTitreSlider">C'EST UN MODE DE VIE</span>
              <h2 class="titreSlider">Une large sélection de produits et équipements sanitaires</h2>
              <h3 class="titreSlider2">Découvrez nos marques Ceratube</h3>
              <button class="btn voirPlusBtnRouge">ACHETER MAINTENANT <i class="fa fa-chevron-right" aria-hidden="true"></i></button>
            </div>
            <div class="col-sm-4">

            </div>
          </div>
        </div>
      </div>
      <div class="carousel-item sliderItem" style="background-image:url('assets/front/images/bg-s3.jpg');" >
        <div class="container">
          <div class="row">
            <div class="col-sm-8 slideContent">
              <span class="surTitreSlider">C'EST UN MODE DE VIE</span>
              <h2 class="titreSlider">Les meilleurs produits de marque à des prix imbattables !</h2>
              <h3 class="titreSlider2">Découvrez notre gamme premium</h3>
              <button class="btn voirPlusBtnRouge">ACHETER MAINTENANT <i class="fa fa-chevron-right" aria-hidden="true"></i></button>
            </div>
            <div class="col-sm-4">

            </div>
          </div>
        </div>
      </div>
    </div>
    <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Previous</span>
    </button>
    <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Next</span>
    </button>
</div>
</div>
<!-- Header + Slider -->
      <div class="container-fluid contentGris">
         <div class="container-fluid container-lg debutDePage">
            <!-- bloc des catégories -->
            <div class="row blocCategorie">
               <a routerLink="/category/6" class="col-6 col-lg-2 col-md-4 text-center categoryBloc">
                  <div class="catImgs" style="background-image:url('assets/front/images/sanitaire.jpeg')"></div>
                  <div class="accueilTitleCats">Sanitaire</div>
                  <!-- <button class="acceuilBtnCats">Découvrir <i class="fa fa-chevron-right" aria-hidden="true"></i></button> -->
               </a>
               <a routerLink="/category/3" class="col-6 col-lg-2 col-md-4 text-center categoryBlocAlt">
                  <div class="catImgs" style="background-image:url('assets/front/images/cuisine.jpeg')"></div>
                  <div class="accueilTitleCatsAlt">Cuisine</div>
                  <!-- <button class="acceuilBtnCatsAlt">Découvrir <i class="fa fa-chevron-right" aria-hidden="true"></i></button> -->
               </a>
               <a routerLink="/category/4"class="col-6 col-lg-2 col-md-4 text-center categoryBloc">
                  <div class="catImgs" style="background-image:url('assets/front/images/plomberie.jpeg')"></div>
                  <div class="accueilTitleCats">Plomberie</div>
                  <!-- <button class="acceuilBtnCats">Découvrir <i class="fa fa-chevron-right" aria-hidden="true"></i></button> -->
               </a>
               <a routerLink="/category/2" class="col-6 col-lg-2 col-md-4 text-center categoryBlocAlt">
                  <div class="catImgs" style="background-image:url('assets/front/images/chauffage.jpeg')"></div>
                  <div class="accueilTitleCatsAlt">Chauffage</div>
                  <!-- <button class="acceuilBtnCatsAlt">Découvrir <i class="fa fa-chevron-right" aria-hidden="true"></i></button> -->
               </a>
               <a routerLink="/category/1" class="col-6 col-lg-2 col-md-4 text-center categoryBloc">
                  <div class="catImgs" style="background-image:url('assets/front/images/isolation2.jpeg')"></div>
                  <div class="accueilTitleCats">Aeration, ventilation et isolation</div>
                  <!-- <button class="acceuilBtnCats">Découvrir <i class="fa fa-chevron-right" aria-hidden="true"></i></button> -->
               </a>
               <a routerLink="/robimeds" class="col-6 col-lg-2 col-md-4 text-center categoryBlocAlt">
                  <div class="catImgs" style="background-image:url('assets/front/images/silvia-bg.jpg')"></div>
                  <div class="accueilTitleCatsAlt">Robimed</div>
                  <!-- <button class="acceuilBtnCatsAlt">Découvrir <i class="fa fa-chevron-right" aria-hidden="true"></i></button> -->
               </a>
            </div>
            <!-- bloc des catégories -->
            <!-- Nos marques -->
            <div class="row nosMarques">
               <div class="col-sm-12 titreRubrique text-center">
                  NOS MARQUES
                  <div class="separTitres"></div>
               </div>
               <div class="col-sm-12 sousTitreRubrique text-center">
                  Spécialiste réputé des équipements sanitaires!
               </div>
            </div>
            <carousel height="150" loop="true" autoplay="true" transitionDuration="100" autoplayInterval="1500" >
              <!-- <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/16.jpg" />
              </div> -->
              <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/41.png" />
              </div>
              <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/19.png" />
              </div>
              <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/37.png" />
              </div>
              <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/38.png" />
              </div>
              <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/49.png" />
              </div>
              <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/64.png" />
              </div>
              <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/118.png" />
              </div>
              <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/117.png" />
              </div>
              <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/74.png" />
              </div>
              <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/21.png" />
              </div>
              <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/44.jpg" />
              </div>
              <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/90.jpg" />
              </div>
              <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/104.jpg" />
              </div>
              <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/121.jpg" />
              </div>
              <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/122.jpg" />
              </div>
              <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/119.jpg" />
              </div>
              <!-- <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/17.jpg" />
              </div>
              <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/18.jpg" />
              </div>
              <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/22.png" />
              </div>
              <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/28.png" />
              </div>
              <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/30.png" />
              </div>
              <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/35.png" />
              </div>
              <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/47.jpg" />
              </div>
              <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/48.png" />
              </div>
              <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/50.jpg" />
              </div>
              <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/61.png" />
              </div>
              <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/68.png" />
              </div>
              <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/73.png" />
              </div>
              <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/85.png" />
              </div>
              <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/87.jpg" />
              </div>
              <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/88.png" />
              </div>
              <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/89.jpg" />
              </div>
              <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/91.png" />
              </div>
              <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/92.png" />
              </div>
              <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/93.png" />
              </div>
              <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/101.png" />
              </div>
              <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/111.jpg" />
              </div>
              <div class="col product-item logoMark mx-auto carousel-cell">
                <img class="" src="assets/logos/125.png" />
              </div> -->
            </carousel>
            <!-- Nos marques FIN -->
         </div>
      </div>
      <div class="container">
         <!-- Les nouveautés -->
         <div class="row lesNouveautes">
            <div class="col-sm-12 titreRubrique text-center">
               LES NOUVEAUTÉS
               <div class="separTitres"></div>
            </div>
            <div class="col-sm-12 sousTitreRubrique text-center">
               Découvrez notre dernière collection
            </div>
            <div class="col-6 col-sm-3 ProductBundle" *ngFor="let product of lastProducts?.slice(0, 8);">
              <app-card-product [product]="product" ></app-card-product>
            </div>
            <div class="col-sm-12 text-center">
              <a [routerLink]="['products/',11]" class="btn voirPlusBtn">Voir tout <i class="fa fa-chevron-right" aria-hidden="true"></i></a>
            </div>
         </div>
         <!-- Les nouveautés FIN -->
      </div>
      <!-- Les A-propos -->
      <div class="container-fluid contentGris nextContainer containerPading">
          <div class="container-fluid gradientApropos">
            <div class="container">
              <div class="row rowApropos">
                <div class="col-sm-5">
                  <img src="assets/front/images/Mask_Group_5@2x.png" alt="" class="img-fluid aproposImg"/>
                </div>
                <div class="col-sm-1">
                </div>
                <div class="col-sm-6">
                  <div class="sousTitreRubriqueLeft">
                    À propos de nous
                  </div>
                  <div class="separApropos"></div>
                  <p class="descriptionApropos">
                    <p><strong>Ceratube : la référence sur le marché sanitaire au Maroc</strong></p>
                    <p>Ceratube est une société marocaine spécialisée dans l’importation et la distrubution de matériels sanitaires, plomberie, robinetterie...</p>

                  <a [routerLink]="['/apropos']" class="btn voirPlusBtnRouge">En savoir plus <i class="fa fa-chevron-right" aria-hidden="true"></i></a>
                </div>
              </div>
            </div>
          </div>
        </div>
          <!-- Les A-propos FIN -->
      <!-- Les Robimed -->
      <div class="container-fluid containerPading">
          <div class="container-fluid gradientRobimed">
            <div class="container">
              <div class="row rowApropos rowBimed">
                <div class="col-12 col-md-6 col-xl-6 text-end">
                  <div class="sousTitreRubriqueLeft">
                    Robimed®
                  </div>

                  <div class="righterSepar">
                    <div class="separApropos"></div>
                  </div>

                  <p class="descriptionApropos">
                    En tant qu’ambassadeur des équipements sanitaires au Maroc, et grâce à notre expérience de plus de 25 ans, nous nous sommes engagés à introduire sur le marché des produits faciles à exploiter, et viables en qualité.
  Nous sommes particulièrement attentifs à une utilisation quotidienne irréprochable, qui tient en compte l’économie d’eau et la protection de l'environnement. De ce fait, nous tenons à ce que chacun de nos produits représente l’harmonie parfaite de technologie, de qualité et de design.</p>
                  <a href="/robimeds" class="btn voirPlusBtnRouge">Voir toutes les collections <i class="fa fa-chevron-right" aria-hidden="true"></i></a>
                </div>
                <div class="col-12 col-md-1">
                </div>
                <div class="col-12 col-md-5">
                  <img src="assets/front/images/Mask_Group_5@2x.png" alt="" class="img-fluid aproposImg"/>
                </div>
              </div>
            </div>
          </div>
        </div>
          <!-- Les Robimed FIN -->
          <!-- Banners -->
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6 p-0">
              <a href="#"><img src="assets/front/images/MaskGroup9.jpg" alt="" class="img-fluid"></a>
            </div>
            <div class="col-sm-6 p-0">
              <a href="#"><img src="assets/front/images/MaskGroup10.jpg" alt="" class="img-fluid"></a>
            </div>
          </div>
        </div>
        <!-- Banners Fin -->
        <!-- Best sellers -->
        <div class="container">
          <div class="col-sm-12 mt-5 titreRubrique text-center">
             BEST SELLERS
             <div class="separTitres"></div>
          </div>
          <div class="col-sm-12 sousTitreRubrique text-center">
             Découvrez nos produits les plus vendus
          </div>
          <div class="row g-4 mx-auto  pb-5" >
            <carousel height="500" autoplay="true" >
              <div class = "col product-item mx-auto carousel-cell" *ngFor="let product of listFournisseur?.slice(0, 15);">
                <app-card-product [product]="product" ></app-card-product>
              </div>
            </carousel>
          </div>

        </div>
        <!-- Best sellers Fin -->
        <!-- Blog -->
        <!-- <div class="container-fluid contentGris">
          <div class="container">
            <div class="row pb-5 g-5">
              <div class="col-sm-12 mt-0">
                  <div class="col-sm-12 mt-5 titreRubrique text-center">
                     BLOG
                     <div class="separTitres"></div>
                  </div>
                  <div class="col-sm-12 sousTitreRubrique text-center">
                     Inspirations
                  </div>
              </div>
              <div class="col-sm-4">
                  <a href="#" class="articleContainer">
                    <div class="articleImg" style="background-image:url('assets/front/images/imgblog1.png')"></div>
                    <div class="articleContent">
                      <div class="articleMeta">
                        22 OCTOBRE 2021
                      </div>
                      <div class="articleShortDes">
                        Lorem Ipsum Dolor Sit Amet, Consetetur Sadipscing Elitr.
                      </div>
                      <div class="articleShowMore">
                        Découvrir plus >>
                      </div>
                    </div>
                  </a>
              </div>
              <div class="col-sm-4">
                  <a href="#" class="articleContainer">
                    <div class="articleImg" style="background-image:url('assets/front/images/imgblog2.png')"></div>
                    <div class="articleContent">
                      <div class="articleMeta">
                        22 OCTOBRE 2021
                      </div>
                      <div class="articleShortDes">
                        Lorem Ipsum Dolor Sit Amet, Consetetur Sadipscing Elitr.
                      </div>
                      <div class="articleShowMore">
                        Découvrir plus >>
                      </div>
                    </div>
                  </a>
              </div>
              <div class="col-sm-4">
                  <a href="#" class="articleContainer">
                    <div class="articleImg" style="background-image:url('assets/front/images/imgblog3.png')"></div>
                    <div class="articleContent">
                      <div class="articleMeta">
                        22 OCTOBRE 2021
                      </div>
                      <div class="articleShortDes">
                        Lorem Ipsum Dolor Sit Amet, Consetetur Sadipscing Elitr.
                      </div>
                      <div class="articleShowMore">
                        Découvrir plus >>
                      </div>
                    </div>
                  </a>
              </div>
            </div>
          </div>
        </div> -->
        <!-- Fin Blog -->
